var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('AccessPassword'),(!_vm.hideHeader && !_vm.vuex_h5)?_c('PageHeader'):_c('pageHeaderMobile'),_c('router-view'),(!_vm.hideFoot)?_c('PageFoot'):_vm._e(),_c('cartWin'),_c('compareWin'),_c('productQuickWinVue')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }